import React, { useMemo, useEffect, useRef } from 'react'
import Color from 'color'
import { isMobile } from '../common/util'
import { textDirectionClass } from '../common/labels'

const AppWrapper = ({ bot, locale, children }) => {
  // Compute theme once per bot/locale
  const theme = useMemo(() => {
    const mainColor = Color(bot.pwa.manifest.theme_color)
    return {
      direction: textDirectionClass(locale),
      palette: {
        primary: {
          main: mainColor.string(),
          contrastText: mainColor.isLight() ? '#000' : '#fff',
        },
      },
    }
  }, [bot, locale])

  // Eval any JS snippet on mount, once
  useEffect(() => {
    if (bot.pwa.extra_js) {
      try {
        // eslint-disable-next-line no-eval
        eval(bot.pwa.extra_js)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    }
  }, [bot])

  // Inject CSS into the <style> tag
  const styleRef = useRef(null)
  useEffect(() => {
    if (styleRef.current && theme) {
      const { palette } = theme
      styleRef.current.textContent = `:root {
  --botsquad-main-color: ${palette.primary.main};
  --botsquad-main-contrast-text: ${palette.primary.contrastText};
}
.chat-screen--wrapper {
  background: white;
}
.chat-screen--wrapper .bubble-group .bubble.text.self span {
  color: ${palette.primary.contrastText}
 }
header, header a {
  color: ${palette.primary.contrastText}
}
.app--wrapper {
  background-color: ${palette.primary.main}
}
${bot.pwa.extra_css || ''}`
    }
  }, [theme, bot])

  if (!theme) return null

  return (
    <div className={`app--wrapper ${isMobile() ? 'mobile' : 'desktop'} ${textDirectionClass(locale)}`}>
      <style ref={styleRef} />
      {children}
    </div>
  )
}

export default AppWrapper
